const validate = (state) => {
    const errors = {};
    
    const patronEmail = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/;
    const patronPassword = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{6,20}$/;
    
    
    if(!state.email) errors.email = 'Fiel is required'
    if (state.email && !patronEmail.test(state.email)) errors.email = 'Entre una dirección de email válida'
    if (state.email.length > 250){
      errors.email = 'Email must be least to 250 characters';
    }
   
    

    if(!state.password) errors.password = 'Field is required' 
    if (!patronPassword.test(state.password)) errors.password = 'La contraseña debe tener entre 6 y 20 caracteres, al menos un número, una letra mayúscula y una minúscula'
    
    if  (state.passwordRep && (state.password !== state.passwordRep)) errors.passwordRep = 'La contraseña debe coincidir' 
    
    return errors;
}

export default validate;